import { BodyEditRegisteredItem, BodyRegisteredNewItem, ParamsGetItemNear, ParamsRequestListDropItem, ParamsRequestListRegistered } from '@/types/item';
import ApiService from './ApiService';
import { PagingRequest } from '@/types/http';

export default class ItemApi extends ApiService {
    getDetailItem(id: string) {
        return this.get(`end/item/${id}`);
    }

    getListItem(params: PagingRequest) {
        return this.get(`end/item?page=${params.page}&size=${params.size}`);
    }

    putListItemAssigned(payload) {
        return this.put('end/assign-item', payload);
    }

    getListAllItem() {
        return this.get('system/item');
    }

    getListColected(params: ParamsRequestListDropItem) {
        return this.get(`end/item-collector/my-items-collected?page=${params.page}&size=${params.size}&type=${params.type}`);
    }

    colectItemSuccess(id) {
        return this.put(`end/item-collector/collect-item/${id}`);
    }

    detailItemCollected(id) {
        return this.get(`end/item-collector/item/${id}`);
    }

    reportItem(id) {
        return this.put(`end/item-collector/report-item/${id}`);
    }

    getItemNearUser(params: ParamsGetItemNear) {
        return this.get(`end/item-collector/items-nearby?latitude=${params.lat}&longitude=${params.long}`);
    }

    pushNotification() {
        return this.post('end/notification/push');
    }

    useItem(id) {
        return this.put(`end/item-collector/use-item/${id}`);
    }

    getListItemRegistered(params: ParamsRequestListRegistered) {
        return this.get(`end/registered-item?page=${params.page}&size=${params.size}&status=${params.status}&activity=${params.activity}`);
    }

    deleteItemRegistered(id) {
        return this.delete(`end/item/${id}`);
    }

    getDetailItemRegistered(id) {
        return this.get(`end/item/${id}`);
    }

    registerNewItem(body: BodyRegisteredNewItem) {
        return this.post('end/item', body);
    }

    editRegisteredItem(body: BodyEditRegisteredItem) {
        const bodyPost = {
            fileId: body.file_id,
            title: body.title,
            description: body.description,
            status: body.status
        };
        return this.put(`end/item/${body.id}`, bodyPost);
    }
}
